module.exports = __webpack_public_path__ + "img/img8.dcee4ac9.png";